import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { UserProvider } from './context/userContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import { CalendarioProvider } from './context/calendarioContext';
import { ReservationProvider } from './context/reservationContext';
import { Provider } from 'react-redux';
import { store } from './util/reducer';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <UserProvider>
        <CalendarioProvider>
          <ReservationProvider>
            <Provider store={store}>
              <App />
            </Provider>
          </ReservationProvider>
        </CalendarioProvider>
      </UserProvider>
    </ChakraProvider>
  </React.StrictMode>
);
